import React from 'react';

export const pageMeta = {
  "name": "Web Worker API",
  "link": "/javascript/web-api/worker"
};

export default function JavascriptWebApiWorker() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Web Worker API</h2>
      <p>Route: /javascript/web-api/worker</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
